module.exports = __webpack_public_path__ + "static/the-switch-customer-journey-f0021fda54ef304d25b81e85efb0c430.jpg";